export default {
  actions: {
    async getOchinCoreTeamUser({ commit }, { username, coreTeamRole }) {
      const user = null;
      return commit("setCoreTeamRole", { user, coreTeamRole });
    },
  },
  mutations: {
    setCoreTeamRole(state, { user, coreTeamRole }) {
      state[coreTeamRole] = user;
    },
    setOchinUserList(state, list) {
      state.ochinUserList = list;
    },
  },
  getters: {
    getByUsername: state => username => {
      return state.ochinUserList.find(item => {
        return item.username === username;
      });
    },
  },
  namespaced: true,
  state: {
    leadership: [
      {
        label: "Chief Executive Officer",
        displayName: "Abby Sears ",
        email: "searsa@ochin.org ",
        firstName: "Abby",
        lastName: "Sears",
        username: "searsa",
      },
      {
        label: "Chief Experience Officer",
        displayName: "Kim Klupenger",
        email: "klupengerk@ochin.org",
        firstName: "Kim",
        lastName: "Klupenger",
        username: "klupengerk",
      },
      {
        label: "Chief Financial Officer",
        displayName: "Brenda Garske",
        email: "garskeb@ochin.org",
        firstName: "Brenda",
        lastName: "Garske",
        username: "garskeb",
      },
      {
        label: "Chief Medical Officer",
        displayName: "Scott Fields, MD",
        email: "fieldssa@ochin.org",
        firstName: "Scott",
        lastName: "Fields, MD",
        username: "fieldssa",
      },
      {
        label: "Chief Information Security Officer",
        displayName: "Paul Matthews",
        email: "matthewsp@ochin.org",
        firstName: "Paul",
        lastName: "Matthews",
        username: "mathewsp",
      },
    ],
    ochinUserList: [],
    ochinInstallAnalyst: null,
    ochinInstallSupportAnalyst: null,
    ochinProjectCoordinator: null,
    ochinProjectManager: null,
    ochinProjectSponsor: null,
    ochinRevenueCycleAnalyst: null,
  },
};
